import * as api from '../../api/api-carpeta-digital';
import { 
    GET_CONFIG_FORM30,
    GET_DATOS_IMPLICADO_TERCERO,
    GET_COMBO_DOCUMENTOS,
    GET_URL_CARPETA,
    CLEAR_COMBO,
    GET_URL_CARPETA_ORIGEN
    
} from '../types';

export const configuracionFormAction30 = (query) => ({
    type: GET_CONFIG_FORM30,
    payload: api.getConfiguracionForm30(query)
});
export const obtenerDatosImplicadoTerecero = (query) => ({
    type: GET_DATOS_IMPLICADO_TERCERO,
    payload: api.getDatosImplicadoTercero(query)
});
export const obtenerComboDocumentos = (query) => ({
    type: GET_COMBO_DOCUMENTOS,
    payload: api.getComboDocumentos(query)
});
export const obtenerUrlCarpeta = (url) => ({
    type: GET_URL_CARPETA,
    payload: url
});
export const clearComboDocument = (limpiar) => ({
    type: CLEAR_COMBO,
    payload: limpiar
});
export const obtenerDataCarpeta = (query) => ({
    type: GET_URL_CARPETA_ORIGEN,
    payload: api.getUrlCarpeta(query)
});
